import { createApp } from 'vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/ru'
import App from './App.vue'
import router from './router'
import './style/main.css'

// Настройка dayjs для начала недели с понедельника
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/ru'

dayjs.extend(updateLocale)
dayjs.updateLocale('ru', { weekStart: 1 })
dayjs.locale('ru')

// User utilities (from f1e/js/user-utils.js)
window.userDisplay = function() {
  if (window.current_user && window.current_user.login) {
    return window.current_user.login
  }
  return window.USER_EMAIL || ''
}

window.userInitials = function() {
  const name = window.userDisplay()
  if (!name) return '?'
  const parts = name.split(/[\s@._-]+/)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase()
  }
  return name.substring(0, 2).toUpperCase()
}

window.logout = async function() {
  try {
    await fetch('/api/logout', { method: 'GET' })
    window.location.href = '/login'
  } catch (e) {
    console.error(e)
  }
}

if (!window.is_user_in_role) {
  window.is_user_in_role = function(role) {
    return window.USER_ROLES && window.USER_ROLES.includes(role)
  }
}

// Глобальный перехват 401: при истёкшей/отсутствующей сессии редиректим на форму логина.
// Авторизационные ручки пропускаем, чтобы не зациклиться.
const AUTH_BYPASS_PREFIXES = ['/api/auth/', '/api/logout']

function resolveUrl(input) {
  const raw = typeof input === 'string' ? input : (input && input.url) || window.location.href
  return new URL(raw, window.location.origin)
}

const __rawFetch = window.fetch
window.fetch = async function (...args) {
  const res = await __rawFetch(...args)
  try {
    if (res.status === 401) {
      const url = resolveUrl(args[0])
      const path = url.pathname
      const isAuth = path.startsWith('/api/') && AUTH_BYPASS_PREFIXES.some(p => path.startsWith(p))
      const alreadyOnLogin = /^\/(login|ios\/login)/.test(window.location.pathname)
      if (path.startsWith('/api/') && !isAuth && !alreadyOnLogin) {
        const redirect = encodeURIComponent(window.location.pathname + window.location.search)
        // Мобильное приложение (iOS/PWA) ведёт на свою форму, десктоп — на свою
        const target = window.location.pathname.startsWith('/ios')
          ? `/ios/login?redirect=${redirect}`
          : `/login?redirect=${redirect}`
        window.location.replace(target)
      }
    }
  } catch (e) {
    /* не блокируем запрос ошибкой обработчика */
  }
  return res
}

// Регистрация service worker (PWA): позволяет установить приложение и работать офлайн
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      console.error('Service worker registration failed', err)
    })
  })
}

const app = createApp(App)

app.use(router)
app.use(ElementPlus, { locale })

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')